// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d7-4";
export var closeButton = "_d7-6";
export var dismissButton = "_d7-3";
export var editImageWithAiContainer = "_d7-8";
export var imageUploadWrapper = "_d7-7";
export var misspelledWord = "_d7-5";
export var spellCheckContainer = "_d7-2";
export var spin = "_d7-1";
export var spinning = "_d7-0";